export const documentationTopics = [
  {
    group: "Start",
    topics: [
      { slug: "create-a-model", routeName: "documentation-create-model", title: "Create a Scio model", summary: "Build, run and validate a model from programme setup to analysis." },
      { slug: "scenarios", routeName: "documentation-scenarios", title: "Work with scenarios", summary: "Create options, preserve lineage and compare results safely." },
    ],
  },
  {
    group: "Build",
    topics: [
      { slug: "assemblies-activities", routeName: "documentation-assemblies-activities", title: "Assemblies and Activities", summary: "Turn governed scope into a traceable model of work, resources and quantities." },
      { slug: "locations", routeName: "documentation-locations", title: "Locations", summary: "Give model scope a spatial context with points, zones and working areas." },
      { slug: "schedules", routeName: "documentation-schedules", title: "Schedules and WBS", summary: "Plan model work and connect it to external programme schedules." },
      { slug: "logistics", routeName: "documentation-logistics", title: "Logistics", summary: "Convert model demand into movements, routes, transport and capacity evidence." },
    ],
  },
  {
    group: "Evaluate",
    topics: [
      { slug: "analysis", routeName: "documentation-analysis", title: "Analysis and diagnostics", summary: "Run the model, validate evidence and interpret outputs." },
    ],
  },
  {
    group: "Control",
    topics: [
      { slug: "governance", routeName: "documentation-governance", title: "Governance and collaboration", summary: "Manage access, concurrent work and accepted results." },
    ],
  },
];

export const flatDocumentationTopics = documentationTopics.flatMap((group) => group.topics);

export function adjacentDocumentationTopics(slug) {
  const index = flatDocumentationTopics.findIndex((topic) => topic.slug === slug);
  return {
    previous: index > 0 ? flatDocumentationTopics[index - 1] : null,
    next: index >= 0 && index < flatDocumentationTopics.length - 1 ? flatDocumentationTopics[index + 1] : null,
  };
}
